import React from 'react';

import ssIMG from './images/steven_stat_75x75.gif';
import sldeIMG from './images/120x60_Geizhals_Logo_DE.png';

import klarnaImg from './images/klarna.png';
import visaMastercardAmexImg from './images/visa_mastercard_amex_20.png';
import PayPalImg from './images/paypal.png';

import lunaImages from './images/luna-grafik.png';
import zahlungen from './images/footer_zahlung_small.jpg';

import information from './Footer/icon-information-weiss.svg';
import kundenservice from './Footer/icon-kundenservice-weiss.svg';
import uhr from './Footer/icon-uhr-weiss.svg';
import bezahlen from './Footer/icon-bezahlen-weiss.svg';
import phone from './Footer/icon-phone-weiss.svg';

import {
  showFooterMiddlePart,
  showFooterPartner,
  facebookIMG,
  instagramIMG,
  twitterIMG,
  youtubeIMG,
  pinterestIMG,
  getFacebookName,
  getShopName,
  getInstagramName,
  getTwitterName,
  getYouTubeName,
  getPinterestName,
} from './overrides';

//import packageJson from '../../../package.json';

import './FooterMoluna.scss';
import {
  browserUrlToReactUrl,
  reactUrlToBrowserUrl,
} from '../../../../../urlParse';
import MolLink from './Menu/MolLink';

interface FooterMolunaProps {
  domainPrefix: string;
  showPartnerDiv: boolean;
  footerLinks: {
    pages_id: number;
    pages_title: string;
    alt_url: string;
  }[];
}

export default class FooterMoluna extends React.Component<FooterMolunaProps> {
  render() {
    const footerMenu = (
      <div id="footerMenu" className="onerow-fluid">
        <div id="navSuppWrapper">
          <div id="footer-menu">
            <div id="footerHead">
              <table id="footerHeadTable">
                <tbody>
                  <tr>
                    <td>
                      <img src={information} alt="Persönlicher Service" />
                    </td>
                    <td>
                      <MolLink to="/kontakt" href="/kontakt">
                        <span>Persönlicher Service</span>
                        <br />
                        in Greven an der Ems
                      </MolLink>
                    </td>
                    <td>
                      <img src={uhr} alt="Telefonzeiten" />
                    </td>
                    <td>
                      <MolLink to="/kontakt" href="/kontakt">
                        <span>Mo - Fr</span>
                        <br />
                        10-16 Uhr
                      </MolLink>
                    </td>
                    <td>
                      <img src={phone} alt="Unsere Telefonnummer" />
                    </td>
                    <td>
                      <a href="tel:+4925718072880">
                        <span>02571/8 07 28 80</span>
                        <br />
                      </a>
                    </td>
                    <td>
                      <img src={bezahlen} alt="Zahlung" />
                    </td>
                    <td>
                      <MolLink to="/zahlung" href="/zahlung">
                        <span>Zahlung</span>
                        <br />
                        auf Rechnung
                      </MolLink>
                    </td>
                    <td>
                      <img src={kundenservice} alt="BUCHBUTLER" />
                    </td>
                    <td>
                      <span>Große Auswahl</span>
                      <br />
                      Günstige Preise
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id="footer-one" className="layer1">
              <h2>Informationen</h2>
              <ul className="content2">
                <li>
                  <MolLink to="/impressum" href="/impressum">
                    Impressum
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/agb" href="/agb">
                    AGB
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/datenschutz" href="/datenschutz">
                    Datenschutz
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/faq" href="/faq">
                    FAQ
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/howToStart" href="/howToStart">
                    Seite Buchbutler - wie gehts los?
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/batterieentsorgung" href="/batterieentsorgung">
                    Batterieentsorgung
                  </MolLink>
                </li>
                <li>
                  * alle Preise zzgl. gesetzl. MwSt. und zzgl. Versand
                  <br />
                  Unser Angebot richtet sich ausschließlich an Firmenkunden.
                </li>
              </ul>
            </div>

            <div id="footer-three" className="layer1">
              <h2>Über uns</h2>
              <ul className="content1">
                <li>
                  <MolLink to="/kontakt" href="/kontakt">
                    Kontakt
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/ueberuns" href="/ueberuns">
                    Über uns
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/login" href="/login">
                    Kunde werden
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/login" href="/login">
                    Login
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/DerBUCHBUTLER" href="/DerBUCHBUTLER">
                    Der BUCHBUTLER
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/versandkosten" href="/versandkosten">
                    Versandkosten
                  </MolLink>
                </li>
                <li>
                  <MolLink to="/versandkosten_all" href="/versandkosten_all">
                    shipping costs
                  </MolLink>
                </li>
              </ul>
            </div>

            <div id="footer-four" className="layer1">
              <h2>Zahlung</h2>

              <ul className="content1">
                <MolLink to="/zahlung" href="/zahlung">
                  <img src={zahlungen} alt="Zahlarten" />
                </MolLink>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );

    let version = 'develop';
    if (process.env.CI_PIPELINE_ID != null)
      version = '#' + process.env.CI_PIPELINE_ID;

    let buildYear = new Date().getFullYear();

    return (
      <div>
        <footer id="footer">
          {footerMenu}
          {showFooterPartner() ? (
            <div id="shoppartner">
              {this.props.showPartnerDiv ? (
                <React.Fragment>
                  <a
                    href="http://www.idealo.de/preisvergleich/Shop/302706.html"
                    target="_blank"
                  >
                    <img
                      src="https://img.idealo.com/folder/Shop/302/7/302706/s1_rating_extern2.png"
                      alt="idealo"
                      className="partner"
                    ></img>
                  </a>
                  <a href="http://www.geizkragen.de" target="_blank">
                    <img src={ssIMG} className="partner"></img>
                  </a>
                  <a href="http://geizhals.at" target="_blank">
                    <img src={sldeIMG} className="partner"></img>
                  </a>
                </React.Fragment>
              ) : null}
            </div>
          ) : null}
          <div className="copyright">
            <div id="social-media">
              {getFacebookName() != '' ? (
                <a
                  href={'https://www.facebook.com/' + getFacebookName()}
                  target="_blank"
                  title={getShopName() + ' auf Facebook'}
                >
                  <img
                    src={facebookIMG}
                    alt="facebook link"
                    className="smi facebook"
                  ></img>
                </a>
              ) : null}
              {getInstagramName() != '' ? (
                <a
                  href={'https://www.instagram.com/' + getInstagramName() + '/'}
                  target="_blank"
                  title={getShopName() + ' auf Instagram'}
                >
                  <img
                    src={instagramIMG}
                    alt="instagram link"
                    className="smi instagram"
                  ></img>
                </a>
              ) : null}
              {getTwitterName() != '' ? (
                <a
                  href={'https://twitter.com/' + getTwitterName()}
                  target="_blank"
                  title={getShopName() + ' bei Twitter'}
                >
                  <img
                    src={twitterIMG}
                    alt="twitter link"
                    className="smi twitter"
                  ></img>
                </a>
              ) : null}
              {getYouTubeName() != '' ? (
                <a
                  href={'https://www.youtube.com/channel/' + getYouTubeName()}
                  target="_blank"
                  title={getShopName() + ' bei YouTube'}
                >
                  <img
                    src={youtubeIMG}
                    alt="youtube link"
                    className="smi youtube"
                  ></img>
                </a>
              ) : null}
              {getPinterestName() != '' ? (
                <a
                  href={'https://de.pinterest.com/' + getPinterestName() + '/'}
                  target="_blank"
                  title={getShopName() + ' auf Pinterest'}
                >
                  <img
                    src={pinterestIMG}
                    alt="pinterest link"
                    className="smi pinterest"
                  ></img>
                </a>
              ) : null}
            </div>

            <div id="siteinfoLegal" className="legalCopyright">
              © {buildYear}{' '}
              <a href={this.props.domainPrefix + '/'}>"BUCHBUTLER"</a> · Powered
              by React {version}
              <div className="bottom_button">&nbsp;</div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
